import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import {
  getNonGeneralWidgetUrl,
  NON_GENERAL_WIDGET,
  trackWidgetClick,
} from './utils'
import { Anchor } from 'components/Anchor'

import type { IToolkit } from './typings'

const toolkitPlaceholderIconPath =
  'https://storage.googleapis.com/belajar-fe-cdn-staging/images/CLWidgets/toolkit_placeholder_icon.png'

const BaseWidget = React.forwardRef<
  HTMLDivElement,
  IToolkit & { className?: string }
>(
  (
    {
      title,
      toolkitType,
      kelas,
      fase,
      className,
      thumbnailUrl,
      id,
      trackerWidgetData,
    },
    ref
  ) => {
    const url = getNonGeneralWidgetUrl({ type: NON_GENERAL_WIDGET.Toolkit, id })
    return (
      <Anchor href={url} className="last:mb-0 mb-2 block">
        <div
          className={clsx(
            'widget-component',
            'rounded border border-subdued py-3 pr-4 mb-2',
            'grid grid-cols-[88px_1fr]',
            'cursor-pointer',
            className
          )}
          ref={ref}
          onClick={() =>
            trackWidgetClick({
              ...trackerWidgetData,
              widgetValue: {
                ...trackerWidgetData.widgetValue,
                url,
              },
            })
          }
        >
          <div className="w-16 self-start justify-self-center aspect-[64/85] object-cover rounded">
            <img
              src={thumbnailUrl || toolkitPlaceholderIconPath}
              alt="toolkit_placeholder_icon"
              width="64"
              height="85"
            />
          </div>
          <div>
            <Text className="mb-1" variant="helper" color="disabled">
              {toolkitType === 'Modul Ajar/RPP+'
                ? `${toolkitType} • ${kelas}`
                : `Fase ${fase}`}
            </Text>
            <Text className="mb-0 line-clamp-2" variant="body-bold">
              {title}
            </Text>
          </div>
        </div>
      </Anchor>
    )
  }
)
BaseWidget.displayName = 'Toolkit'

export default BaseWidget
